import { useCallback, useContext, useEffect, useState } from 'react';
import { atom } from 'recoil';

import { getDemoOffer } from '../../../data/demo_project/offer';
import { OfferQuery, useOfferLazyQuery } from '../../../generated/graphql_offer';
import { context as dependencyContext } from '../../context/dependency';

export const offerAtom = atom<OfferQuery['offer'] | null>({
  key: 'offerAtom',
  default: null,
});

export const offerLoadingAtom = atom<boolean>({
  key: 'offerLoadingAtom',
  default: true,
});

export const useOffer = () => {
  const { errorPresenter, offerApiClient } = useContext(dependencyContext);
  const [loadOffer, { data: dataOffer, loading, error, refetch }] = useOfferLazyQuery({ client: offerApiClient });
  const [demo, setDemo] = useState<OfferQuery['offer'] | undefined>();
  const load = useCallback(
    (offerId: string) => {
      const demo = getDemoOffer(offerId);
      setDemo(demo);
      if (demo) {
        return;
      }
      loadOffer({
        variables: {
          id: offerId,
        },
      });
    },
    [loadOffer],
  );
  useEffect(() => {
    if (error) {
      errorPresenter.showAsNonFatal(error);
    }
  }, [errorPresenter, error]);

  const data: OfferQuery | undefined = demo ? { offer: demo } : dataOffer;
  return {
    loadOffer: load,
    dataOffer: data,
    loadingOffer: loading,
    errorOffer: error,
    refetchOffer: refetch,
  };
};
